const trainNumbersForm = {
  bindings: {
    selection: '<',
    onFormSubmit: '&',
    hasEdit: '<',
    isLocked: '<',
  },
  templateUrl:
    '/modules/pis-tool/train-numbers/train-numbers-form/train-numbers-form.html',
  controller: 'TrainNumbersFormController',
};

angular
  .module('pis-tool.module')
  .component('trainNumbersForm', trainNumbersForm);
